<template>
  <navigation-menu-item target-path="balance" title="יתרת העו״ש וחיובי האשראי"
                        v-on:navigate="$emit('navigate')"
                        :disabled="!allowNavigationToBalancePage" />
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import NavigationMenuItem from './NavigationMenuItem.vue';
import { SUBSCRIPTION_STATES } from '../../constants/subscription-state';

export default {
  name: 'BalancePageMenuItem',
  components: { NavigationMenuItem },
  async created() {
    await this.fetchCredentials();
  },
  computed: {
    ...mapState('credentials', ['credentialsList']),
    ...mapState('subscriptionState', ['subscriptionState']),
    ...mapState('applicationState', ['cashflowState']),
    ...mapGetters('applicationState', ['cashflowTypes']),
    ...mapGetters('sourceFields', ['getSourceByKey']),
    allowNavigationToBalancePage() {
      return !this.hasDiscountApiAccount
        && !this.isDormant
        && !this.isPreTrial
        && !this.cashflowOutOfDate
        && !this.cashflowBlocked;
    },
    hasDiscountApiAccount() {
      return _.some(this.credentialsList, credentials => credentials.sourceName === this.getSourceByKey('discount-api').sourceName);
    },
    isDormant() {
      return [SUBSCRIPTION_STATES.DORMANT_AFTER_CANCELED, SUBSCRIPTION_STATES.DORMANT_AFTER_TRIAL].includes(this.subscriptionState);
    },
    isPreTrial() {
      return SUBSCRIPTION_STATES.PRE_TRIAL === this.subscriptionState;
    },
    cashflowOutOfDate() {
      return this.cashflowState === this.cashflowTypes.OUT_OF_DATE;
    },
    cashflowBlocked() {
      return this.cashflowState === this.cashflowTypes.BLOCKED;
    },

  },
  methods: {
    ...mapActions('credentials', ['fetchCredentials']),
  },
};
</script>

<style scoped lang="scss">
  @import "~base-ui/src/scss/riseup-colors";

  .disabled {
    color: $riseup_gray_1;
    cursor: not-allowed;
  }
</style>
